
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import {
IsValid,
setSStore,
setSStore2,
getSStore,
getSStore2,
setLStore,
getLStore,
saveToken,
isCjWxChannel,
getXAccountUrl,
getXAccountUrl2,
getUrlObj,
clearLogined,
removeSStore,
throttle
} from "@js/public/mUtils";
import * as myCode from "@js/public/code";
import sLoading from "@/components/publicComponents/sLoading";
import resultDialog from "@/components/publicComponents/resultDialog";
import WXConfig from '@/assets/js/wx.jsapi'

export default {
name: "personalCenter",
components: {
Group,
Cell,
"my-sloading": sLoading,
resultDialog,
XDialog,
XButton
},
data() {
return {
main: false,
showUpgrade: false,
trainNotice: false,
headImg: "",
openAccountIsSuccess: false,
openResult: {},
openFlag: false,
xinNumber: '0',
isNewLqbUser: '1',
lqb: {
money: '0'
},
formTitle: '',
isOpenLqb: true,
from: {
totalMarketValue: 0,
totalFloating: 0,
totalDayIncome: 0,
cjbaoMarketValue: 0,
fundMarketValue: 0,
otherAssetMarketValue: 0,
totalIncome: 0,
},
info: {
name: "",
riskAbilityStr: "",
},
comeInItems: [
{
imgName: "#my_deal",
name: "我的交易",
link: "/dealDetail",
},
{
imgName: "#my_timeinvest",
name: "我的定投",
link: "/myTimeInvest",
},
{
imgName: "#my_bankcard",
name: "银行卡",
link: "/myCard",
},
],
showMoney: true,
accessToken: "",
trainShow: false,
setIntervalTest: null,
gxShow: false,
mesStyle: { width: "300", height: "290" },
openId: "oA68Q1rZRFIKCKptOlu04fl1ubtk",
noticeTrainShow: true,

zcUrl: "http://cjwxtest.cjhxfund.com:8887/comLight/#/capitalFind/fundFind", // 'http://10.201.224.160:8081/comLight-0.0.1_20200226/index.html#/capitalFind/fundFind?fundAcco=%2a3M000000684&channelCode=WX'//'http://10.201.200.25:8081/acm/app.htm#/mainTopBoard/mainboard'

};
},

activated() {
console.log("----activated");
this.clearPersonalCenterUserInfo();
this.eventBus.$emit("changeMenu", 3);
this.WXConfig.wxShowMenu('4')
this.openFlag = false;
if (!this.$store.state.isBindCard) {
this.tipNoBindCard();
}
if (getSStore("xhcWl") === '0') {
this.trainShow = true
} else {
this.trainShow = false
}
this.checkOpenAccountState();
this.getXAccountBalance()
this.$store.commit('tabBarNumber', 3)






},

created() {
if (window.location.hostname == "wx.cjhxfund.com") {
this.zcUrl = "https://wmsc.cjhxfund.com/comLight/#/capitalFind/fundFind";
}
console.log(this.main, 'main');
console.log(this.openAccountIsSuccess, 'openAccountIsSuccess');
},
mounted() {
this.$emit("changeMenu", 3);
if (IsValid(getSStore("token"))) {
console.log("有token");

this.checkLogin().then((res) => {
if (res) {
this.eventBus.$on("updataRiskState", () => {
this.getUserInfo();
});

this.getUserInfo();
this.getPersonal().then((res) => {
this.mainLoaded(this);
});
} else {
this.toPage("/login", {});
}
});
} else {
console.log("notoken");
this.$http
.post("/customer/login/openid", { source: "wx", distinctId: this.sa.getPresetProperties()._distinct_id })
.then((res) => {
if (res.code === 0) {
saveToken(res.body.token);

this.getUserInfo();
this.getPersonal().then((res) => {
this.mainLoaded(this);
});
} else {
this.toPage("/login", {});
}
});
}
},
deactivated() {
console.log(11111118881);
this.leaveClear()
},
methods: {



leaveClear() {
console.log(8871);
window.clearInterval(this.setIntervalTest);　　
this.setIntervalTest = null
console.log(this.setIntervalTest, 99991);
},
getSetInter() {
var that = this
if(!that.setIntervalTest) {
that.setIntervalTest = window.setInterval(() => {
console.log(that.setIntervalTest,'that.setIntervalTest')
that.clearOver()
},5000)
}
},
clearOver() {
var time = parseInt(new Date().getHours())
console.log(77777723, time);
if(time > 5 && time < 19) {
this.noticeTrainShow = true
this.gxShow = false
window.clearInterval(this.setIntervalTest)
this.setIntervalTest = null
return
};
if(this.noticeTrainShow === true) {
this.noticeTrainShow = false
} else {
this.noticeTrainShow = true
}
},
getTimes:throttle(function() {
var time = parseInt(new Date().getHours())
console.log(time)
if(time > 18 || time <= 5) {
if(this.from.isWorkDate === '1') {
this.getSetInter()
this.gxShow = true
} else {
this.noticeTrainShow = true
this.gxShow = false
window.clearInterval(this.setIntervalTest)
this.setIntervalTest = null
}
} else {
this.noticeTrainShow = true
this.gxShow = false
window.clearInterval(this.setIntervalTest)
this.setIntervalTest = null
}
}),
goEstimateValue() {
if (window.location.hostname == "wx.cjhxfund.com") {
window.location.href = `https://wmsc.cjhxfund.com/mEstimateValue/#/?phoneCode=${this.info.mobile}`
}else{
window.location.href = `http://wxzxtest2.cjhxfund.com/rtv-mobile/index.html#/?phoneCode=${this.info.mobile}`
}
},
openNotice() {
this.trainNotice = true
},
goToast() {
this.trainNotice = false
},
async goBusiness() {
const isNext = await this.currencyCheck()
console.log(isNext, 'isNext');
if (isNext === true) {
this.sa.track('my_page_button_click', {
third_module: '我的交易'
})
this.toPage('/dealDetail', {})
}
},
async goMyCard() {
const isNext = await this.currencyCheck()
console.log(isNext, 'isNext');
if (isNext === true) {
this.sa.track('my_page_button_click', {
third_module: '银行卡'
})
this.toPage('/myCard', {})
}
},
async goTrains() {
const isNext = await this.currencyCheck()
console.log(isNext, 'isNext');
if (isNext === true) {
this.sa.track('my_page_button_click', {
third_module: '我的小目标'
})
this.goTarget();
}
},
currencyCheck() {
return this.$http.post("/customer/state", {}).then((res) => {
if (res.code === 0) {
if (!res.body.state) {

if (res.body.certValid == "10") {
const result = {
title: "您还未开户",
content: "完成实名绑卡后，即可进行下一步哦",
description: "",
icon: "warn",
buttons: [
{
type: "primary",
text: "去实名",
link: "/registerTwo?action=register&source=wx",
active: true,
},
{
type: "default",
text: "关闭",
link: "-2",
active: false,
},
],
};
this.mesStyle = { width: "300", height: "290" };
this.openResult = result;
this.openFlag = true;
return false
} else if (res.body.certValid == "11") {
const result = {
title: "提示",
content: res.body.message,
description: "",
icon: "warn",
buttons: [
{
type: "primary",
text: "确定",
link: "-2",
active: true,
},
],
};
this.mesStyle = { width: "300", height: "230" };
this.openResult = result;
this.openFlag = true;
return false
} else {
const result = {
title: "去完善个人信息",
content: res.body.message,
description: "",
icon: "warn",
buttons: [
{
type: "primary",
text: "去完善",
link: "/personal",
active: true,
},
{
type: "default",
text: "关闭",
link: "-2",
active: false,
},
],
};
this.mesStyle = { width: "300", height: "290" };
this.openResult = result;
this.openFlag = true;
return false
}
} else {
return true
}
}
});
},
navigateTo(url, text) {
console.log(77881);
this.sa.track('my_page_button_click', {
third_module: text
})
if (url === null) {
this.toRescue();
} else if (url) {
this.toPage(url, {});
} else {
this.goTarget();
}
},
nav() {
this.sa.track('my_page_button_click', {
button_name: '基金资产'
})
this.toPage('/fundAsset', {});
},
upgradeKnow() {
this.showUpgrade = false
},
goTarget() {
const xAccountUrl = getXAccountUrl2("pages/mysmalltarget/index/index", '1');
window.location.href = xAccountUrl

},
goPage() {
this.sa.track('my_page_button_click', {
button_name: this.formTitle
})
setSStore("onlyBagNum", '2');
this.$http.post("/white/checkIsWhiteList",{channel: 'QB'}).then(res => {
if (res.code === 0) {
if (this.isNewLqbUser === '0') {
setSStore("jdLqbBag", '3');
this.toPage('/changeBagClone', {})
} else if(this.isNewLqbUser === '1') {
this.toPage('/changeBag', {})
}
}
})
},
getWhite() {
this.$http.post("/white/checkIsWhiteList",{channel: 'XZH'}).then(res => {
if (res.code === 0) {
if (this.xinNumber === '0') { // 未开通
const xAccountUrl = getXAccountUrl("xAccount/xAccoIndex2", '0');
window.location.href = xAccountUrl
} else {
const xAccountUrl = getXAccountUrl("xAccount/xIndex", '1');
window.location.href = xAccountUrl
}
}
})
},
getXAccountBalance() { // 查询鑫账户
this.$http
.post("/xinAcct/balance",{})
.then(res => {

this.xinNumber = res.body.data.xinOpenFlag + '' || '0'
this.lqb.money = res.body.data.balance
});
},
async toGo(val) {
const isNext = await this.currencyCheck()
if (isNext === true) {
this.sa.track('my_page_button_click', {
button_name: '鑫账户'
})
this.getWhite()
}
},
toRescue() {

window.location.href = this.zcUrl;
},
testCors() {



},

checkOpenAccountState() {
this.openAccountIsSuccess = true;
this.openFlag = false;
this.getUserInfo();
this.getPersonal();
},

getPersonal() {
return this.$http.post("/asset/summary", {}).then((res) => {

if (res.code === myCode.NO_BINDCARD) {


this.from = {
totalMarketValue: "--",
totalFloating: "--",
totalDayIncome: "--",
cjbaoMarketValue: "--",
fundMarketValue: "--",
otherAssetMarketValue: "--",
totalIncome: "--",
};
} else {
this.formTitle = '零钱包'
this.isNewLqbUser =  res.body.summary.isNewLqbUser
if (res.body.summary.isOldUser && res.body.summary.isOldUser === '0') {
this.isOpenLqb = true
} else if (res.body.summary.isOldUser && res.body.summary.isOldUser === '1') {
this.openDia()
this.isOpenLqb = false
}
this.from = res.body.summary;
this.getTimes()
}
});
},

openDia() {
if (getSStore2("isOpenLqbNumber") === null || getSStore2("isOpenLqbNumber") === undefined) {
setSStore2("isOpenLqbNumber", 1)
}
const isNum = Number(getSStore2("isOpenLqbNumber")) + 1
setSStore2("isOpenLqbNumber", isNum)
},

getDouble: function (val) {
if (val == "--") {
return "--";
} else {
return Math.floor(val * 100) / 100;
}
},

clearPersonalCenterUserInfo() {

if (getSStore("personalCenterUserInfo")) {
this.info = JSON.parse(getSStore("personalCenterUserInfo"));
} else {
this.info.name = "******";
this.info.riskAbilityStr = "";

}
},

getUserInfo() {
this.$http.post("/customer/info", {}).then((res) => {
setSStore("personalCenterUserInfo", res.body.info);
this.info = res.body.info;

this.zcUrl =
this.zcUrl +
"?fundAcco=" +
this.info.fundAcct +
"&identityType=" +
this.info.identityType +
"&identityNo=" +
this.info.identityNo +
"&channelCode=WX"; 
if (isCjWxChannel()) {
this.getHeadImg();
}
});
},

getAccesToken() {
return this.$http.post("wc/accessToken", {}).then((res) => {
this.accessToken = res;
return res;
});
},

getHeadImg() {
setSStore("openid", this.info.openid);
if (IsValid(getLStore(this.info.openid))) {
this.headImg = getLStore(this.info.openid);
} else {
this.$http
.get(
this.$http.defaults.baseURL.slice(
0,
this.$http.defaults.baseURL.length - 4
) +
"/wc/userImg?openid=" +
this.info.openid,
{}
)
.then((res) => {
if (res.code === 0) {
if (IsValid(res.body.userImg)) {
this.headImg = res.body.userImg;
setLStore(this.info.openid, res.body.userImg);
}
}
})
.catch(() => {});
}
},

checkLogin() {
return this.$http.post("/customer/info", {}).then((res) => {
if (res.code === 0) {
return true;
} else {
return false;
}
});
},
},
computed: {},
};



// WEBPACK FOOTER //
// ./src/components/personalCenter/personalCenter.vue